import app from '@/common/app';
import user from '@/common/user';
import metaData from './meta-data';
import _ from 'lodash';
// import qs from 'qs';

class Permission {
  constructor() {
    // 初始数据
    this.metaData = _.cloneDeep(metaData);
    // 提供出去的权限
    this.permissionData = {
      roleArr: []
    };
  }
  // 获取商户权限数据
  async getPermissionData() {
    const _this = this;
    // const queryStr =
    //   location.search.split('?')[1] || location.hash.split('?')[1];
    // const query = qs.parse(queryStr);
    return new Promise(resolve => {
      function getUserInfoCb(val) {
        console.timeEnd('app.getUserInfo');
        let data = val ? JSON.parse(val) : {};
        console.log(`getUserInfoCb方法得到数据：${val}`);
        if (process.env.VUE_APP_BUILD_MODE === 'development') {
          data = {
            amc_name: 'daichenhui@huishoubao.com.cn',
            amc_id: '1227',
            real_name: '戴晨晖',
            permission: [
              // {
              //   permissionId: '1',
              //   permissionKey: '0',
              //   permissionName: '门店TAB'
              // },
              // {
              //   permissionId: '2',
              //   permissionKey: '1',
              //   permissionName: '上门TAB'
              // },
              // {
              //   permissionId: '3',
              //   permissionKey: '2',
              //   permissionName: '后端TAB'
              // },
              // {
              //   permissionId: '4',
              //   permissionKey: '3',
              //   permissionName: '小豹哥TAB'
              // },
              // {
              //   permissionId: '5',
              //   permissionKey: '4',
              //   permissionName: '已验货商家'
              // },
              {
                permissionId: '6',
                permissionKey: '5',
                permissionName: '第三方门店'
              },
              {
                permissionId: '7',
                permissionKey: '6',
                permissionName: '外部系统'
              }
            ]
          };
        }
        user.setUserInfo(data);
        _this.authorityList = data.permission || [];
        _this.init();
        resolve();
      }
      window.getUserInfoCb = getUserInfoCb;
      if (process.env.VUE_APP_BUILD_MODE === 'development') {
        window.getUserInfoCb();
      } else {
        app.getUserInfo();
        console.time('app.getUserInfo');
      }
    });
  }
  // 初始化权限
  init() {
    const _this = this;
    this.clearPermission();
    this.metaData.roleArr.forEach(item => {
      const f = this.authorityList.find(
        el => el.permissionKey === item.authKey
      );
      if (!f) return;
      const obj = {
        ...item,
        orderTypeArr: [],
        stockTypeArr: [],
        dataTypeArr: []
      };
      obj.orderTypeArr = checkTypeArrAuth(item.orderTypeArr);
      obj.stockTypeArr = checkTypeArrAuth(item.stockTypeArr);
      obj.dataTypeArr = checkTypeArrAuth(item.dataTypeArr);
      this.permissionData.roleArr.push(obj);
    });
    function checkTypeArrAuth(data) {
      const arr = [];
      data.forEach(item => {
        const f =
          _this.authorityList.find(el => el.permissionKey === item.authKey) ||
          true;
        if (f) {
          const obj = {
            ...item,
            funArr: []
          };
          if (item.funArr) {
            item.funArr.forEach(el => {
              const flag =
                _this.authorityList.find(e => e.permissionKey === el.authKey) ||
                true;
              if (flag) obj.funArr.push(el);
            });
          }
          arr.push(obj);
        }
      });
      return arr;
    }
  }
  // 检查权限
  async check() {
    if (!this.value || this.value.roleArr.length < 1) {
      await this.getPermissionData();
    }
    return this.value.roleArr.length > 0;
  }
  // 权限数据
  get value() {
    return this.permissionData;
  }
  // 更新权限数据中数量角标
  updateOrderTypeNum(params) {
    this.permissionData.roleArr.forEach(item => {
      item.orderTypeArr.forEach(el => {
        if (Object.prototype.hasOwnProperty.call(params, el.numKey)) {
          el.num = Number(params[el.numKey]) > 99 ? '99' : params[el.numKey];
          if (Number(el.num) === 0) el.num = '';
        }
        el.orderStatusArr.forEach(i => {
          if (Object.prototype.hasOwnProperty.call(params, i.numKey)) {
            i.num = Number(params[i.numKey]) > 99 ? '99' : params[i.numKey];
            if (Number(i.num) === 0) i.num = '';
          }
        });
      });
    });
  }
  // 清空权限
  clearPermission() {
    this.permissionData = {
      roleArr: []
    };
  }
}

export default new Permission();
